import type { WireArticleBlock } from '../../../api/types'
import { InlineContent } from '../common/InlineContent'
import { PortionMark } from '../common/PortionMark'

type Block = Extract<WireArticleBlock, { type: 'paragraph' }>

export function ParagraphBlock({ block }: { block: Block }) {
  return (
    <p className="article-body text-fg">
      <PortionMark classification={block.classification} disseminationControls={block.disseminationControls} />
      <InlineContent children={block.children} />
    </p>
  )
}
